<template>
  <div>
    <SiruiSearch
      ref="formItem"
      :query="baseFormData"
      :columns="formColumn"
      :isQueryPanel="false"
      :rules="formRules"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
  </div>
</template>

<script>
  import BaseInfoMixin from './../BaseInfoMixin.js';
  import { baseForm, baseFormRule } from './index.js';
  export default {
    name: 'BaseInfoContract',
    mixins: [BaseInfoMixin],
    props: {
      contractTotalAmount: {
        type: [Number, String],
        default: 0,
      },
      contractStatus: {
        type: String,
        default: '',
      },
      // 远程获取数据反填表单上面
      fetchData: {
        type: Object,
        default: () => {},
      },
      // 是否定量
      disabledIsRestrict: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      formRules() {
        return baseFormRule(this);
      },
      formColumn: {
        set(val) {
          console.log(val);
        },
        get() {
          // return baseForm(this, this.contractStatus);
          return this._getStatusRelatedBaseForm();
        },
      },
    },
    methods: {
      _getStatusRelatedBaseForm() {
        let tableColumns = baseForm(this);

        let cs = this.contractStatus;

        let disabledList = [
          'contractCreateDate',
          'contractNo',
          'projectName',
          'contractOperaterName',
          // 'contractTotalAmount',
          'isFixedPrice',
        ];
        if (cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061') {
          disabledList = disabledList.concat([
            'contractName',
            'customerName',
            'projectInitiationNo',
            'contractBusinessDepartment',
            'contractCurrency',
          ]);
        }

        if (cs == 'ZT02' || (cs == 'ZT03' && cs != 'ZT061')) {
          disabledList.push('contractBusinessCompanyNo');
        }

        if (this.baseFormData.contractBusinessCompanyNo == '') {
          disabledList.push('contractBusinessDepartment');
        }

        // if (!this.baseFormData.projectInitiationNo || this.baseFormData.projectInitiationNo == '') {
        //   disabledList.push('customerName');
        // }

        if (this.disabledIsRestrict) {
          disabledList.push('isRestrict');
        }

        if (
          cs != '' &&
          cs != 'ZT06' &&
          cs != 'ZT05' &&
          cs != 'ZT051' &&
          cs != 'ZT021' &&
          cs != 'ZT061'
        ) {
          disabledList = disabledList.concat([
            'signDate',
            'contractValidStart',
            'contractValidEnd',
            'personChargeName',
            'receiptMethod',
            'overShippedPercentage',
            'shortShippedPercentage',
            'performanceBondPayMethodCode',
            'performanceBond',
            'warrantyClause',
            'isRestrict',
            'marginAmount',
            'mark',
          ]);
        }

        return tableColumns.map((item) => {
          if (disabledList.includes(item.prop)) {
            return { ...item, disabled: true };
          }
          if (item.prop == 'recyclingCompanyFileNo' || item.prop == 'platformCompanyFileNo') {
            if (item.type == 'select') {
              let state = cs != '' && cs != 'ZT06' && cs != 'ZT05' && cs != 'ZT061';
              return { ...item, disabled: state };
            } else {
              return { ...item, disabled: true };
            }
          }
          return item;
        });
      },
    },
    watch: {
      contractTotalAmount: {
        handler(val) {
          this.baseFormData = {
            ...this.baseFormData,
            contractTotalAmount: val + '',
            businessContractTotalAmount: val + '',
          };
          this.formColumn = baseForm(this, this.contractStatus);
        },
        immediate: true,
      },
      fetchData: {
        handler(val) {
          if (Object.keys(val).length) {
            let newObj = {};
            for (const key in val) {
              if (typeof val[key] == 'number') {
                newObj[key] = val[key] + '';
              } else {
                newObj[key] = val[key];
              }
            }
            this.baseFormData = newObj;
            this.getProjectByProjectNo(this.baseFormData.projectInitiationNo);
          }
        },
        immediate: true,
        deep: true,
      },
      'baseFormData.isRestrict': {
        handler(val) {
          this.setISRestrict(val);
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
